import { Component } from '../lib/component'
export class Browser extends Component {
    constructor(options){
        super(options)
        this.active
        this.window(options)
    }
    window(options){
        if(this.active) return
        const loader = ui.element('div',ui.element('i',{ class : 'fa-duotone fa-2x fa-spinner-third fa-spin', style:'position: absolute;left: 50%;top: 50%;'})),
              tabs = ui.template('playlist-tabs')
        tabs.querySelector('#content').append(options.content)
        tabs.querySelector('#widgets').append(options.widgets)
        tabs.querySelector('#tickertapes').append(options.tickertapes)



        const modal = ui.modal.instance({
            title : options.title,
            footer : false,
            size : 'xl',
            body : tabs,
            buttonSave : __('Add'),
            onOpen(){
                const title = ui.modal.title.textContent
                ui.modal.body.querySelectorAll('.nav-tabs .nav-link').forEach( tab => {
                    tab.addEventListener('click',event => {
                        const currentTabId = event.currentTarget.dataset.bsTarget.replace('#','')
                        if(currentTabId === 'content')
                            ui.modal.title.textContent = title
                        else
                            ui.modal.title.textContent = event.currentTarget.textContent
                    })
                })
                this.active = true
                ui.modal.body.append(loader)
                options.content.onload = ()=>{
                    //console.log('window.onOpen')
                    loader.remove()

                }
                setTimeout(options.content.onload,100)

            },
            onSave : options.onSave
        })
        setTimeout(options.onLoad,500)
    }
}
